module.exports = __webpack_public_path__ + "7e10341e70824d05b9db983961465f20.pdf";